import React from 'react';
import { IconProvider } from '@/components/ui';

interface ChangeTypeBadgeProps {
  type: 'added' | 'removed' | 'modified' | 'unchanged';
  size?: 'sm' | 'md' | 'lg';
}

export const ChangeTypeBadge: React.FC<ChangeTypeBadgeProps> = ({ type, size = 'md' }) => {
  const config = {
    added: {
      color: 'bg-green-100 text-green-700 dark:bg-green-950/30 dark:text-green-400',
      icon: 'fa-plus',
      label: 'Added',
      iconColor: '#22c55e',
    },
    removed: {
      color: 'bg-red-100 text-red-700 dark:bg-red-950/30 dark:text-red-400',
      icon: 'fa-minus',
      label: 'Removed',
      iconColor: '#ef4444',
    },
    modified: {
      color: 'bg-yellow-100 text-yellow-700 dark:bg-yellow-950/30 dark:text-yellow-400',
      icon: 'fa-pen',
      label: 'Modified',
      iconColor: '#eab308',
    },
    unchanged: {
      color: 'bg-gray-100 text-gray-700 dark:bg-gray-800 dark:text-gray-400',
      icon: 'fa-check',
      label: 'Unchanged',
      iconColor: '#6b7280',
    },
  };

  const { color, icon, label, iconColor } = config[type];

  const sizeClasses = {
    sm: 'text-xs px-1.5 py-0.5',
    md: 'text-sm px-2 py-1',
    lg: 'text-base px-3 py-1.5',
  };

  const iconSizes = {
    sm: 10,
    md: 12,
    lg: 14,
  };

  return (
    <span className={`inline-flex items-center gap-1 rounded font-medium ${color} ${sizeClasses[size]}`}>
      <IconProvider iconstring={icon} size={iconSizes[size]} color={iconColor} />
      {label}
    </span>
  );
};

